import {Pipe, PipeTransform} from '@angular/core';
import {orderBy} from 'lodash';
import {EstimateDetailsSectionEntityDTO, EstimateSectionDisplayRenderType} from '../modals/estimate.modal';

@Pipe({
  name: 'estimateDisplayList'
})
export class EstimateDisplayListPipe implements PipeTransform {

  transform = (section: EstimateDetailsSectionEntityDTO) => {
    let costlines = this.createObject(section.EstimateCostLineItems, EstimateSectionDisplayRenderType.costline);
    let subSections = this.createObject(section.SubEstimateDetails, EstimateSectionDisplayRenderType.subsection);
    let mergedList = [...costlines, ...subSections];
    return orderBy(mergedList, ['SectionWiseOrder'], ['asc']);
  }

  private createObject(data: any, renderedType: EstimateSectionDisplayRenderType) {
    return (data || []).map((obj: any, i: any) => ({
      ...obj,
      isTemplateOpen: false,
      originalObject: obj,
      renderedType: renderedType,
      index: i
    }));
  }

}
